import React, { useContext } from 'react';
import { Paginator } from 'components/Shared';
import { Scaffold } from 'layouts';
import { Navigation } from 'components/Pages/ReverseLogistics'; 
import { HistoryPickupsList } from 'components/Pages/HistoryPickups/PickupsList';
import { HistoryPickupsFilter } from 'components/Pages/HistoryPickups/PickupsFilter';
import { HistoryPickupsContext, HistoryPickupsProvider } from 'contexts/HistoryPickupsContext';

const HistoryPickupsPageContent: React.FC = () => {
  const { onPageChange, pagination } = useContext(HistoryPickupsContext);

  return (
    <Scaffold>
      <div className="w-full flex flex-col gap-6">
        <Navigation />
        <div className="flex-[0_1_100%] flex flex-col bg-white p-6 rounded-md shadow-sm border border-gray-200">
          <HistoryPickupsFilter />
          <HistoryPickupsList />
          <Paginator onPageChange={onPageChange} pagination={pagination} />
        </div>
      </div>
    </Scaffold>
  );
};

export const HistoryPickupsListPage: React.FC = () => (
  <HistoryPickupsProvider>
    <HistoryPickupsPageContent />
  </HistoryPickupsProvider>
);